import { LanguageInfo } from "./LanguageInfo";
import { post } from "./server";
import { TranslationResponse } from "./TranslationResponse";

export class TextTranslator {

  text!: string;
  fromLanguage!: LanguageInfo;
  toLanguage!: LanguageInfo;
  sessionId!:string;

  async translate(): Promise<TranslationResponse> {
    const result: TranslationResponse = await post("translate", {
      text: this.text,
      fromLanguage: this.fromLanguage.code,
      toLanguage: this.toLanguage.code,
      sessionId: this.sessionId,
    });
    return result;
  }
}


